import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import NameField from '@/components/forms/new/formikFormFields/NameField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';

const AttributeField = ({
    darkMode,
    errors,
    touched,
    number,
    submitData,
    platformID,
    setPlatformNumber,
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const platformIndex = submitData?.findIndex(
        (platform) => platform?.platformID === platformID,
    );
    const platform = submitData[platformIndex];
    const fieldName = () => {
        switch (number) {
            case 2:
                return 'attribute2';
            case 3:
                return 'attribute3';
            default:
                return 'attribute1';
        }
    };

    const handleChange = (item) => {
        setPlatformNumber((prev) => {
            const newPlatformNumbers = [...prev];

            newPlatformNumbers[platformIndex] = {
                ...platform,
                [fieldName()]: item?.target.value,
            };
            return newPlatformNumbers;
        });
    };
    const hasError = !!errors?.[fieldName()] && touched?.[fieldName()];
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={hasError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" sx={{ ...stackStyling(), width: '740px' }}>
                <Box width={190}>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Attribute {number}
                    </FormLabel>
                </Box>
                <Field
                    component={NameField}
                    id={fieldName()}
                    name={fieldName()}
                    value={platform?.[fieldName()] || ''}
                    onChange={handleChange}
                    placeholder={`Enter Attribute ${number}`}
                    width="90%"
                    darkMode={darkMode}
                    isInvalid={hasError}
                />
                {isHovered && (
                    <FieldToolTip
                        label={`Enter attribute ${number} for this entity`}
                        ariaLabel={`entity-attribute${number}-tip`}
                        right="20px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};
export default AttributeField;
